export default __webpack_public_path__ + "static/media/volitality.af72f2ba.png";